// Module
var code = `<div id="printPreview" class="modal hide fade" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" ng-form="\$ctrl.printForm">
	<div class="modal-header">
		<h2 id="modalHeader">Print: {{\$ctrl.printDefinition.name}}</h2>
	</div>
	<div class="modal-body">
    <div id="pdf-wrapper" ng-class="{'hidden': \$ctrl.displayPrintInput}">
      <iframe id="prev" class="iframe-preview" type="application/pdf" style="" frameBorder="0">
      </iframe>
      <iframe id="autoprint" class="iframe-preview" type="application/pdf" style="" frameBorder="0">
      </iframe>
    </div>

    <div ng-if="\$ctrl.displayPrintInput" class="horizontal">
      <div class="print-filters" ng-repeat="input in \$ctrl.customVariables">
        <form-section form-title="input.text">
          <section class="print-filters-section">
            <glue-container>
              <select ng-if="input.customVariableConfig.CUSTOM_VARIABLE_TYPE === 'USER'"
                      ng-model="\$ctrl.customVariableInput[input.field]"
                      ng-required="input.customVariableConfig.REQUIRED"
                      ng-options="u.id as u.fullName for u in \$ctrl.signatories">
              </select>

              <customer-picker ng-if="input.customVariableConfig.CUSTOM_VARIABLE_TYPE === 'CUSTOMER'"
                               ng-required="input.customVariableConfig.REQUIRED"
                               on-choose="\$ctrl.selectCustomer(customer, input)"
                               search-criteria="{customerTypes: ['INDIVIDUAL']}">
              </customer-picker>
              <input type="text"
                     ng-if="input.customVariableConfig.CUSTOM_VARIABLE_TYPE === 'CUSTOMER'"
                     disabled ng-model="\$ctrl.customVariableInput[input.field].customerName"
                     ng-required="input.customVariableConfig.REQUIRED" />

              <textarea ng-if="input.customVariableConfig.CUSTOM_VARIABLE_TYPE === 'TEXT'"
                        rows="2"
                        maxlength="{{input.fieldLengthIncludingPadding ? input.fieldLengthIncludingPadding : 4096}}"
                        ng-required="input.customVariableConfig.REQUIRED"
                        ng-model="\$ctrl.customVariableInput[input.field]">
          </textarea>
            </glue-container>
          </section>
        </form-section>
      </div>
    </div>
	</div>

	<div class="modal-footer">
    <button type="button"
            ng-if="\$ctrl.displayPrintInput"
            class="btn btn-success"
            ng-disabled="\$ctrl.printForm.\$invalid"
            ng-click="\$ctrl.generatePreview()">
      Display
    </button>
		<button class="btn btn-print"
						type="button"
            ng-if="!\$ctrl.displayPrintInput && \$ctrl.printData"
            ng-click="\$ctrl.print()">Print</button>
		<button class="btn btn-primary" data-dismiss="modal" aria-hidden="true"
						type="button"
            ng-click="\$ctrl.close()">Exit</button>
	</div>
</div>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/common/print/modal-print-preview.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;